<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/" style="font-weight:700;">首页</router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="12">
      <el-col :span="12" v-for="item in linkList" :key="item.id">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{item.name}}</span>
          </div>
          <a :href="lin.url" target="_blank" v-for="lin in item.list" :key="lin.id">
            <el-button :round="true" :plain="true" class="text item" type="primary">{{lin.name}}</el-button>
          </a>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  name: "home",
  components: {},
  data() {
    return {
      query: {},
      linkList: [], //链接展示
      loading: false
    };
  },
  methods: {
    gotoLogin() {
      this.$router.replace("login");
    },
    getList: function() {
      var _this = this;
      var link = url.getBaseData("getlink");
      $.get(link, {}, data => {
        _this.loading = false;
        _this.linkList = data;
      });
    }
  },
  mounted() {
    //获取链接列表
    this.getList();
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background-color: #f2f2f2;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
  margin-left: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.el-col-12 {
  margin-bottom: 10px;
}
.el-row {
  margin-top: 20px;
}
</style>
